// extracted by mini-css-extract-plugin
export default {"wrapper":"swith_wrapper__qJl6s","wrapper--disabled":"swith_wrapper--disabled__qYy8M","switch":"swith_switch__M6xbp","label":"swith_label__4RXIa","slider":"swith_slider__8wwV9"};